import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Information from './orderTabs/information';
import Position from './orderTabs/position';
import Documents from './shared/documents';
import History from './shared/history';

import CardLayout from '../../../components/CardLayout';
import { userPermissionsSelector } from '../../../ducks/profile';
import Returns from "./orderTabs/returns";
import {createDefaultValueSelector, getCardConfigRequest} from "../../../ducks/gridCard";
import {ORDERS_GRID} from "../../../constants/grids";
import OrderAddingToTransportationsHistory from "./orderTabs/OrderAddingToTransportationsHistory";

const OrderCard = ({
    form,
    onChangeForm,
    name,
    id,
    load,
    isNotUniqueNumber,
    uniquenessNumberCheck,
    settings,
    error,
    title,
    onClose,
    actionsFooter,
    actionsHeader,
    loading,
    goToSoldTo,
}) => {
    const userPermissions = useSelector(state => userPermissionsSelector(state));

    const dispatch = useDispatch();
    const defaultValues = useSelector(createDefaultValueSelector);

    useEffect(()=>{
        !id && dispatch(getCardConfigRequest({name: ORDERS_GRID, configFlag: false}));
    }, []);

    useEffect(() => {
        defaultValues &&
        Object.keys(defaultValues).forEach(key =>
            onChangeForm(null, {name: key, value: defaultValues[key]}),
        );
    }, [defaultValues]);

    const getPanes = () => {
        let obj = [
            {
                menuItem: 'information',
                render: () => (
                    <Information
                        form={form}
                        settings={settings}
                        error={error}
                        load={load}
                        isNotUniqueNumber={isNotUniqueNumber}
                        uniquenessNumberCheck={uniquenessNumberCheck}
                        onChange={onChangeForm}
                        goToSoldTo={goToSoldTo}
                    />
                ),
            }
        ];
        
        if (userPermissions.includes(116)) {
            obj.push({
                menuItem: 'position',
                render: () => (
                    <Position
                        form={form}
                        onChange={onChangeForm}
                        gridName={name}
                        load={load}
                        error={error}
                        settings={settings}
                    />
                ),
            });
        }
        
        if (userPermissions.includes(117)) {
            obj.push({
                menuItem: 'return',
                render: () => (
                    <Returns
                        form={form}
                        settings={settings}
                        error={error}
                        onChange={onChangeForm}
                    />
                ),
            });
        }

        if ((userPermissions.includes(4) || userPermissions.includes(5)) && form.id) {
            obj.push({
                menuItem: 'documents',
                render: () => (
                    <Documents
                        gridName={name}
                        cardId={id}
                        isEditPermissions={userPermissions.includes(5)}
                        canAddDocuments={!form?.cannotAddDocuments}
                    />
                ),
            });
        }

        if (userPermissions.includes(145) && form.id) {
            obj.push({
                menuItem: 'order_adding_to_transportations_history',
                render: () => <OrderAddingToTransportationsHistory form={form} />,
            });
        }

        if (userPermissions.includes(6) && form.id) {
            obj.push({
                menuItem: 'history',
                render: () => <History cardId={id} status={form.status} />,
            });
        }

        return obj;
    };

    return (
        <CardLayout
            title={title}
            actionsFooter={actionsFooter}
            actionsHeader={actionsHeader}
            content={getPanes}
            onClose={onClose}
            loading={loading}
        />
    );
};

export default OrderCard;
